import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const scrollToPageTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

export const scrollElementToPageTop = (element) => {
    if (!element) {
        return;
    }

    const navigationHeight = document.querySelector('.navigation')?.getBoundingClientRect().height || 0;
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
        top: Math.max(elementTop - navigationHeight - 16, 0),
        left: 0,
        behavior: 'auto',
    });
};

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        scrollToPageTop();
    }, [pathname]);

    return null;
}

export default ScrollToTop;
